import React from 'react';
import { useNavigate } from 'react-router-dom';

const NotFound: React.FC = () => {
  const navigate = useNavigate();

  return (
    <div className="notfound-wrapper d-flex align-items-center justify-content-center vh-100 bg-light">
      <div className="notfound-content text-center shadow p-5 rounded bg-white">
        <h1 className="display-1 fw-bold text-purple">404</h1>
        <h3 className="mb-3 fw-semibold">Oops! Page Not Found</h3>
        <p className="text-muted mb-4">
          The page you’re looking for doesn’t exist or has been moved.
        </p>
        <button className="btn btn-purple btn-lg px-4 py-2" onClick={() => navigate('/')}>
          ⬅ Back to Homepage
        </button>
      </div>
    </div>
  );
};

export default NotFound;
